import { Breakpoint, ResponsiveRenderer } from "@flixbus-phx/marketplace-common";
import * as React from "react";
import GreyResultBackground from "../../shared/components/greyResultBackground/GreyResultBackground";
import PartnerHeadline from "../../shared/components/partnerHeadline/PartnerHeadline";
import RideFilter from "../rideFilter/RideFilter";
import RideActions from "./containers/rideActions/RideActions";
import RideListContainer from "./containers/rideListContainer/RideListContainer";
import RideTableBody from "./containers/rideTableBody/RideTableBody";
import RideTableHeader from "./containers/rideTableHeader/RideTableHeader";
import { Grid, GridActionRow, GridTableHeaderRow, GridTableBodyRow } from "./ui/grid/Grid";

const RideOverview: React.FC = () => {
  return (
    <>
      <PartnerHeadline headline="Capacity Manager" />
      <RideFilter showCompletedRideFilterInPopup />
      <GreyResultBackground>
        <Grid>
          <GridActionRow>
            <RideActions />
          </GridActionRow>
          <ResponsiveRenderer hidden={[Breakpoint.XXS, Breakpoint.XS, Breakpoint.SM, Breakpoint.MD, Breakpoint.LG]}>
            <GridTableHeaderRow>
              <RideTableHeader />
            </GridTableHeaderRow>
          </ResponsiveRenderer>
          <GridTableBodyRow>
            <ResponsiveRenderer hidden={[Breakpoint.XXS, Breakpoint.XS, Breakpoint.SM, Breakpoint.MD, Breakpoint.LG]}>
              <RideTableBody />
            </ResponsiveRenderer>
            <ResponsiveRenderer hidden={[Breakpoint.XL]}>
              <RideListContainer />
            </ResponsiveRenderer>
          </GridTableBodyRow>
        </Grid>
      </GreyResultBackground>
    </>
  );
};

export default RideOverview;
